<glxy-form-field required="true">
  <glxy-label>
    {{ 'AUTOMATIONS.EDITOR.FILTERS.PARTNER_DATA.DATA_LABELS.ESTIMATED_ANNUAL_REVENUE' | translate }}
  </glxy-label>
  <mat-select [formControl]="revenueOptionControl" multiple required="true">
    <mat-select-trigger>
      {{ (revenueOptionControl.value?.[0] ? revenueOptionControl.value[0].label : '') | translate }}
      <span *ngIf="revenueOptionControl.value?.length > 1">
        (+{{ revenueOptionControl.value.length - 1 }}
        {{
          (revenueOptionControl.value?.length === 2
            ? 'AUTOMATIONS.EDITOR.FILTERS.OTHER'
            : 'AUTOMATIONS.EDITOR.FILTERS.OTHERS'
          ) | translate
        }})
      </span>
    </mat-select-trigger>
    <mat-option *ngFor="let revenue of revenueOptions" [value]="revenue">
      {{ revenue.label | translate }}
    </mat-option>
  </mat-select>
</glxy-form-field>
